import { render, staticRenderFns } from "./physiologyPdf.vue?vue&type=template&id=98004356&scoped=true&"
import script from "./physiologyPdf.vue?vue&type=script&lang=js&"
export * from "./physiologyPdf.vue?vue&type=script&lang=js&"
import style0 from "./physiologyPdf.vue?vue&type=style&index=0&id=98004356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98004356",
  null
  
)

export default component.exports